import { useEffect, useState } from 'react';
import {
  NavLinkAStyled,
  NavLinkStyled,
  NavMenuMobile,
  NavStyled,
} from './Nav.styled';

import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/unitedOneLogo.png';
import {
  backofficeLink,
  handleSmoothScroll,
  navLinks,
  pathname,
} from '../../helpers/helpers';
import { Div } from '../../styles/Styles';
import { ArrowButtonIcon, HamburgerIcon, Icon, XIcon } from '../../styles/svg';

import { Button } from 'components/Button/Button';

export const Nav = () => {
  const [sticky, setSticky] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();

  const handleMenu = () => setDropdown((prevState) => !prevState);

  const navigate = useNavigate();

  useEffect(() => {
    if (dropdown) {
      handleMenu();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const isSticky = () => {
    const scrollTop = window.scrollY;
    scrollTop >= 50 ? setSticky(true) : setSticky(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  });

  return (
    <>
      <NavStyled $sticky={sticky && !isOpen}>
        <Div $flex $alignCenter $gap='80px'>
          <Link to='/'>
            <img src={logo} alt='united one' />
          </Link>
          <Div $desktop $flex $alignCenter $gap='30px'>
            <a href='#section5'>
              <Button>Who is United One?</Button>
            </a>
            <a href={backofficeLink} target='_blank' rel='noopener noreferrer'>
              <Button $negative $transparent>
                Login
              </Button>
            </a>

            <a href={backofficeLink} target='_blank' rel='noopener noreferrer'>
              <Button $negative $transparent>
                Membership
              </Button>
            </a>
          </Div>
        </Div>
        <Div $desktop>
          <a
            href={backofficeLink + '/login'}
            target='_blank'
            rel='noopener noreferrer'
          >
            <Button>
              Get Started <ArrowButtonIcon />
            </Button>
          </a>
        </Div>
        <Div $mobile>
          <Icon onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <XIcon /> : <HamburgerIcon />}
          </Icon>
        </Div>

        <NavMenuMobile $isOpen={isOpen}>
          {navLinks.map(({ path, name }, i) => {
            if (path === backofficeLink || path === backofficeLink + '/login') {
              return (
                <NavLinkAStyled
                  key={i}
                  href={path}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {name}
                </NavLinkAStyled>
              );
            }
            return (
              <NavLinkStyled
                key={i}
                to={path}
                onClick={(e) => {
                  handleSmoothScroll(e, path, location, navigate);
                  setIsOpen(false);
                }}
              >
                {name}
              </NavLinkStyled>
            );
          })}
        </NavMenuMobile>
      </NavStyled>
    </>
  );
};
